<template>
  <input :value="modelValue" @input="onInput">
</template>

<script>
import Inputmask from 'inputmask'

export default {
  props: {
    modelValue: { type: String, default: '' },
    mask: { type: String, required: true }
  },
  emits: ['update:modelValue'],
  mounted () {
    this.applyMask()
  },
  beforeUnmount () {
    this.$el.inputmask.remove()
  },
  watch: {
    modelValue (value) {
      if (value !== this.$el.value) this.$el.inputmask.setValue(value || '')
    },
    mask () {
      this.$el.inputmask.remove()
      this.applyMask()
    }
  },
  methods: {
    applyMask () {
      Inputmask({ mask: this.mask.replace(/1/g, '9'), clearMaskOnLostFocus: true }).mask(this.$el)
      this.$el.inputmask.setValue(this.modelValue || '')
    },
    onInput (event) {
      const value = event.target.value
      if (value !== (this.modelValue || '')) this.$emit('update:modelValue', value)
    }
  }
}
</script>
